var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 43.2,
    height: 43.2,
    rx: 21.6,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 43.2,
    height: 43.2,
    rx: 21.6,
    stroke: "#979797",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.0286 17.7258H14.0638V30.9206H31.0286V17.7258ZM30.4003 18.3542V29.2952L26.3488 25.8221L23.2383 27.6885L18.7917 22.607L14.6922 26.7065V18.3542H30.4003ZM14.6922 30.2923V27.5949L18.7609 23.5262L23.1111 28.4975L26.2838 26.594L30.4003 30.1224V30.2923H14.6922Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8913 17.4118H17.5196V15.841H33.5419V27.7791H31.3427V28.4075H34.1702V15.2126H16.8913V17.4118Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.6303 24.0092C27.6699 24.0092 28.5153 23.1638 28.5153 22.1242C28.5153 21.0847 27.6699 20.2393 26.6303 20.2393C25.5908 20.2393 24.7453 21.0847 24.7453 22.1242C24.7453 23.1638 25.5908 24.0092 26.6303 24.0092ZM26.6303 20.8676C27.3234 20.8676 27.887 21.4312 27.887 22.1242C27.887 22.8173 27.3234 23.3809 26.6303 23.3809C25.9373 23.3809 25.3737 22.8173 25.3737 22.1242C25.3737 21.4312 25.9373 20.8676 26.6303 20.8676Z",
    fill: "#979797"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.1b43ef7ec7a19176048b639c8ba34e68.svg";
export { ForwardRef as ReactComponent };